import styled from 'styled-components';
const StyledOperationsHubOnboardingHeader = styled.header.withConfig({
  displayName: "StyledOperationsHubOnboardingHeader",
  componentId: "sc-1nobh40-0"
})(["position:relative;background-color:", ";color:", ";padding:16px 20px;"], ({
  theme
}) => theme.color['do-not-use-sorbet'], ({
  theme
}) => theme.color['do-not-use-olaf']);
export default StyledOperationsHubOnboardingHeader;